<script setup>

    import { ref, onMounted } from "vue";
    import Swiper, { Navigation, Scrollbar } from 'swiper';

    let props = defineProps(["answers", "displayMode"]);
    let emits = defineEmits(["onAnswer", "onScrollToBottom"]);

    let isAnswer = ref(false);
    let selectedAnswer = ref(null);
    let refSlider = ref(null);

    function onAnswer (userAnswer)
    {
        if (isAnswer.value)
            return;


        isAnswer.value = true;
        selectedAnswer.value = userAnswer?.value?.answer ?? userAnswer?.answer ?? ""
        emits('onAnswer', userAnswer);
    }

    function setupSlider (  )
    {

        Swiper.use( [ Navigation ] );
        const navButtons = refSlider.value.querySelectorAll( '.swiper-button-prev, .swiper-button-next' );
        const scrollbar  = refSlider.value.querySelectorAll( '.swiper-scrollbar' );

        const swiperOptions = {
            modules       : [ Navigation, Scrollbar ],
            slidesPerView : 1.5,
            spaceBetween  : 0,
        };

        if ( navButtons )
        {
            swiperOptions.navigation = {
                nextEl : refSlider.value.querySelectorAll( '.swiper-button-next' ),
                prevEl : refSlider.value.querySelectorAll( '.swiper-button-prev' ),
            };
        }


        if ( scrollbar )
        {
            swiperOptions.scrollbar = {
                el        : '.swiper-scrollbar',
                draggable : true,
            };
        }


/*console.log(( 'setupSlider', swiperOptions, refSlider.value ))*/;        var swiperInstance = new Swiper( refSlider.value, swiperOptions );

        emits('onScrollToBottom');

        setTimeout( () => {
            emits('onScrollToBottom');
        }, 500);
    }

    function mounted ()
    {
        if (props.displayMode === "carousel")
        {
            setupSlider();
        }

        emits('onScrollToBottom');
    }


    onMounted ( () => {
        setTimeout ( () => {
            mounted();
        }, 100);
    });

</script>

<template>

    <div class="questions swiper" ref="refSlider" v-if="!isAnswer && displayMode === 'carousel'">
        <div class="swiper-wrapper" v-if="!isAnswer">

            <template v-for="answer in answers">
                <div class="swiper-slide data-is-answer question" data-list-answer>

                    <img :src="answer.image" class="img-fluid" alt="">
                    <button
                        type="button"
                        class="question-text"
                        @click="onAnswer(answer)">
                        {{  answer.answer  }}
                    </button>
                </div>
            </template>
        </div>

        <template v-if="answers.length > 1">
            <div class="swiper-scrollbar"></div>
        </template>


    </div>


    <div class="d-flex justify-content-end row answers-group" v-if="!isAnswer && displayMode !== 'carousel'">

        <template v-for="answer in answers" v-if="!isAnswer">
            <button
                type="button"
                @click="onAnswer(answer)"
                class="col col-lg-12 response user-answer">
                {{ answer.answer }}
            </button>
        </template>

        <div class="d-flex justify-content-end " v-if="isAnswer">
            <div class="response user">
                {{ selectedAnswer }}
            </div>
        </div>

    </div>

    <div class="d-flex justify-content-end row answers-group" v-if="isAnswer">
        <div class="d-flex justify-content-end " >
            <div class="response user">
                {{ selectedAnswer }}
            </div>
        </div>
    </div>



</template>

<style scoped>

</style>
